import { InfoButtonDisplayDTO } from "../../models/internal/infobutton-display-dto";

export abstract class BasePageWithToolTip {
    infoButtonDisplayDTORefreshed: InfoButtonDisplayDTO;

    constructor() 
        {
    }

    RefreshDynamicToolTip(refreshInfoButtonDisplayDTO: InfoButtonDisplayDTO)
    {
        this.infoButtonDisplayDTORefreshed = refreshInfoButtonDisplayDTO;
    }

}